import React from 'react';
import { IconProps } from './types';
import cx from 'classnames';
import styles from './SocialIcons.module.scss';

export const X = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    className={cx(styles.base, svgProps.className)}
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M24.4974 0H29.2502L18.8148 11.8819L31.0066 28H21.4391L13.9483 18.2052L5.37269 28H0.619926L11.6753 15.2915L0 0H9.80517L16.5727 8.9476L24.4974 0ZM22.8339 25.2103H25.4686L8.42066 2.68635H5.58967L22.8339 25.2103Z" />
  </svg>
);
